export default __webpack_public_path__ + "static/media/header-main.9f869913.svg";